import React, { useState } from "react";
import moment from "moment";
import "./DeclarationCard.css";
import arrowDown from "../../Assets/arrow-down.svg";
import arrowUp from "../../Assets/arrow-up.svg";

function DeclarationCard(props) {
  const covidDeclarationTime = (id, row) => {
    var dateFormat = "MMM D, YYYY";
    var dayFormat = "dddd";
    var testDateUtc = moment.utc(row.declarationDate);
    var localDate = testDateUtc.local();

    return (
      <div className="declaration__detail__container">
        <div className="declaration__date">
          <p>{localDate.format(dateFormat)}</p>
          <p> {localDate.format(dayFormat)}</p>
        </div>
      </div>
    );
  };

  const declarationDetail = (row) => {
    return (
      <div className="detail">
        <div className="detail__container">
          <div className="covid__container">
            {props.COVID_LIST_HEADER.map((data, index) => {
              return (
                <React.Fragment key={index}>
                  {data.value !== "Date & Time" && data.value !== "Status" && (
                    <div className="covid__symptons">
                      <p>{data.value}</p>
                      <div className="test__result">
                        {data.phiDataFormat(index, row)}
                      </div>
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  const toogleDeclaration = (index) => {
    var element = document.getElementsByClassName("declaration");
    element[index].classList.toggle("expandDeclaration");
    if (element[index].classList.length > 1) {
      element[index].children[0].src = arrowUp;
    } else {
      element[index].children[0].src = arrowDown;
    }
  };

  return (
    <React.Fragment>
      {props.data.map((data, index) => (
        <div
          className="declaration"
          key={index}
          onClick={() => toogleDeclaration(index)}
        >
          <img src={arrowDown} />
          <div className="declaration__container">
            <div className="declaration__top">
              {covidDeclarationTime(index, data)}
              {props.covidResultStatusHandler(index, data)}
            </div>
            {declarationDetail(data)}
          </div>
        </div>
      ))}
      {props.covidListPaginationPanelHandler()}
    </React.Fragment>
  );
}

export default DeclarationCard;
